import {
  Configuration,
  DefaultApi,
  TutorialVideoDto,
  CreateTutorialVideoDto,
  UpdateTutorialVideoDto,
} from '@cratehackers/api-client';
import { config } from '../config';
import { AppIdentifiers } from '../store/slices/token-state.slice';
import { getAppStore } from '../store/storeRef';
import { openApiFetchWrapper } from '../utils/openApiFetchWrapper';

class TutorialVideosApiService {
  private static getApiClient(): DefaultApi {
    const apiConfig = new Configuration({
      basePath: config.API_BASE_URL,
      accessToken: TutorialVideosApiService.getAuthToken(),
      fetchApi: openApiFetchWrapper,
    });
    return new DefaultApi(apiConfig);
  }

  private static getAuthToken(): string {
    const appToken = getAppStore().getState().tokenState[AppIdentifiers.App];
    return appToken && appToken.accessToken ? appToken.accessToken : '';
  }

  static async listActive(): Promise<TutorialVideoDto[]> {
    const apiClient = TutorialVideosApiService.getApiClient();
    return await apiClient.tutorialVideoControllerListActive();
  }

  static async listAll(): Promise<TutorialVideoDto[]> {
    const apiClient = TutorialVideosApiService.getApiClient();
    return await apiClient.tutorialVideoControllerListAll();
  }

  static async create(
    payload: CreateTutorialVideoDto,
  ): Promise<TutorialVideoDto> {
    const apiClient = TutorialVideosApiService.getApiClient();
    return await apiClient.tutorialVideoControllerCreate({
      createTutorialVideoDto: payload,
    });
  }

  static async update(
    id: number,
    payload: UpdateTutorialVideoDto,
  ): Promise<TutorialVideoDto> {
    const apiClient = TutorialVideosApiService.getApiClient();
    return await apiClient.tutorialVideoControllerUpdate({
      id: id.toString(),
      updateTutorialVideoDto: payload,
    });
  }

  static async remove(id: number): Promise<void> {
    const apiClient = TutorialVideosApiService.getApiClient();
    await apiClient.tutorialVideoControllerRemove({ id: id.toString() });
  }

  static async removePermanent(id: number): Promise<void> {
    const apiClient = TutorialVideosApiService.getApiClient();
    await apiClient.tutorialVideoControllerRemovePermanent({
      id: id.toString(),
    });
  }
}

export { TutorialVideosApiService as TutorialVideosApi };
export type {
  TutorialVideoDto,
  CreateTutorialVideoDto,
  UpdateTutorialVideoDto,
};

const TutorialVideosApi = TutorialVideosApiService;
export default TutorialVideosApi;
